// NO EDITAR A MANO
import type {ModuloLoader} from "../..";
import type {Error} from "../../error";
import type {Footer} from "../../footer";
import type {Home} from "../../home";
import type {Idiomas} from "../../idiomas";
import type {Landings} from "../../landings";
import type {Menu} from "../../menu";

class Modulo implements ModuloLoader {
    /* INSTANCE */
    public get error(): Promise<Error> { return import(/* webpackChunkName: "i18n/en-US/error" */ "i18n/.src/enUS/error").then(module=> module.default); }
    public get footer(): Promise<Footer> { return import(/* webpackChunkName: "i18n/en/footer" */ "i18n/.src/en/footer").then(module=> module.default); }
    public get home(): Promise<Home> { return import(/* webpackChunkName: "i18n/en/home" */ "i18n/.src/en/home").then(module=> module.default); }
    public get idiomas(): Promise<Idiomas> { return import(/* webpackChunkName: "i18n/en/idiomas" */ "i18n/.src/en/idiomas").then(module=> module.default); }
    public get landings(): Promise<Landings> { return import(/* webpackChunkName: "i18n/en/landings" */ "i18n/.src/en/landings").then(module=> module.default); }
    public get menu(): Promise<Menu> { return import(/* webpackChunkName: "i18n/en/menu" */ "i18n/.src/en/menu").then(module=> module.default); }

    public constructor() {
    }
}

export default new Modulo();
